<template>
<div class="rolesMContainer">
  <div class="mainContent" :style="styleObject">
    <div class="query">
      <el-input placeholder="角色名称" v-model="queryForm.name"></el-input>
      <el-input placeholder="角色描述" v-model="queryForm.comment"></el-input>
      <el-select size="small" v-model="queryForm.isSystem" placeholder="是否系统角色" clearable>
        <el-option label="是" value="1" key="1"></el-option>
        <el-option label="否" value="0" key="0"></el-option>
      </el-select>
      <el-select size="small" v-model="queryForm.isEnabled" placeholder="是否启用" clearable>
        <el-option label="启用" value="1" key="1"></el-option>
        <el-option label="禁用" value="0" key="0"></el-option>
      </el-select>
      <button v-if="rolePermit('role:query')" class="primaryBtn" @click="search">搜索</button>
      <button v-if="rolePermit('role:add')" class="primaryBtn" @click="handleAddClick">新增</button>
    </div>
    <div class="tableBox contentShowArea">
      <border-table :loading="rolesLoading" :tableData="roleList"  :pageSizes="[10, 20, 50]" :pages="pagination" @currentChange="handleRoleCurrentChange" @sizeChange="handleRoleSizeChange">
        <el-table-column prop="id" label="ID" width="200" sortable="custom"></el-table-column>
        <el-table-column prop="name" label="名称" sortable="custom"></el-table-column>
        <el-table-column prop="comment" label="角色描述"></el-table-column>
        <el-table-column label="是否内置角色" width="200">
              <template #default="{row}">
                <span v-if="row.isSystem" style="color:#67C23A">是</span>
                <span v-else style="color:#ed4014">否</span>
              </template>
            </el-table-column>
        <el-table-column label="是否启用" width="200">
          <template #default="{row}">
            <span v-if="row.isEnabled" style="color:#808080">启用</span>
            <span v-else style="color:#ed4014">禁用</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" sortable="custom"></el-table-column>        
        <el-table-column fixed="right" label="操作" width="220">
          <template #default="{row}">
            <el-button :style="{color:!row.isSystem?'#DD3071':'#ccc'}" v-if="row.isEnabled" class="delBtn" type="text" icon="el-icon-unlock" :disabled="row.isSystem" @click="disabledRole(row)">禁用</el-button>
            <el-button v-else class="editBtn" :style="{color:row.isSystem?'#ccc':''}" type="text" icon="el-icon-unlock" :disabled="row.isSystem" @click="enabledRole(row)">启用</el-button>
             <el-button v-if="rolePermit('role:edit')" class="editBtn" type="text" icon="el-icon-edit-outline" @click="handleEditClick(row)" >编辑</el-button> 
            <el-button v-if="rolePermit('role:del')" :style="{color:row.isSystem?'#ccc':'#DD3071'}" class="delBtn" type="text" icon="el-icon-delete" :disabled="row.isSystem" @click="handleDeleteClick(row)">删除</el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="name" label="名称"></el-table-column> -->
        <!-- <el-table-column prop="comment" label="描述"></el-table-column> -->
        <!-- <el-table-column prop="systemRole" label="是否是系统角色">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.systemRole == 0">否</el-tag>
            <el-tag v-else-if="scope.row.systemRole == 1" type="danger">是</el-tag>
            <el-tag v-else type="warning">未知</el-tag>
          </template>
        </el-table-column> -->
        <!-- <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button v-if="(scope.row.systemRole == 0 && isPermit('role:edit')) || scope.row.id == 2" :disabled="scope.row.ownerRole" @click="handleEditClick(scope.row)" size="small" class="edit">编辑</el-button>
            <el-button v-if="scope.row.systemRole == 0  && isPermit('role:del')" :disabled="scope.row.ownerRole" @click="handleDeleteClick(scope.row)" size="small" class="del">删除</el-button>
          </template>
        </el-table-column> -->
      </border-table>
    </div>
  </div>

  <el-drawer :title="addRoleDrawer.title" size="900px" :modal="false" :visible.sync="addRoleDrawer.show" @close="handleAddRoleDrawerClose" :wrapperClosable="false" direction="rtl" ref="drawer">
    <div class="drawerWrap">
      <div class="drawerBody">
        <el-form class="formBox" ref="addRoleDrawerForm" :model="addRoleDrawer.form" :rules="addRoleDrawer.formRules" label-position="right" label-width="120px">
          <el-form-item label="角色名称" prop="name">
            <el-input v-model.trim="addRoleDrawer.form.name" type="text" :maxlength="30" placeholder="请输入角色名称"></el-input>
          </el-form-item>
          <el-form-item label="角色描述" prop="comment">
            <el-input v-model.trim="addRoleDrawer.form.comment" type="textarea" :maxlength="50" :rows="3" placeholder="请输入角色描述"></el-input>
          </el-form-item>
          <el-form-item label="权限分配">
            <div class="content-panel privilege-form-item">
              <el-checkbox v-model="addRoleDrawer.checkAll.value" @change="handleAddRoleDrawerCheckAllChange">全选</el-checkbox>
              <div v-for="privilegeGroup in addRoleDrawer.privileges" :key="privilegeGroup.id">
                <one-group-checkboxs ref="addRoleDrawerPrivilege" :group-label="privilegeGroup.name" v-model="privilegeGroup._checkedPrivilegeIds" @change="handleAddRoleDrawerCheckItemChange" :data="privilegeGroup.privileges" key-prop="id" label-prop="name" disabled-prop="_disabled"></one-group-checkboxs>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="drawerFoot">
        <el-button type="primary" @click="handleAddSave" :loading="addRoleDrawer.saving">{{ addRoleDrawer.saving ? '提交中' : '提交' }}</el-button>
        <el-button @click="addRoleDrawer.show = false">取 消</el-button>
      </div>
    </div>

  </el-drawer>

  <el-drawer :title="editRoleDrawer.title" size="900px" :modal="false" :visible.sync="editRoleDrawer.show" @close="handleEditDrawerClose" :wrapperClosable="false" direction="rtl" ref="drawer">
    <div class="drawerWrap">
      <div class="drawerBody">
        <el-form class="formBox" ref="editRoleDrawerForm" :model="editRoleDrawer.form" :rules="editRoleDrawer.formRules" label-position="right" label-width="120px">
          <el-form-item label="角色名称" prop="name">
            <el-input v-model.trim="editRoleDrawer.form.name" :disabled="editRoleDrawer.isSystem" type="text" :maxlength="30" placeholder="请输入角色名称"></el-input>
          </el-form-item>
          <el-form-item label="角色描述" prop="comment">
            <el-input v-model.trim="editRoleDrawer.form.comment" type="textarea" :maxlength="50" :rows="3" placeholder="请输入角色描述"></el-input>
          </el-form-item>
          <el-form-item label="权限分配">
            <div class="content-panel privilege-form-item">
              <el-checkbox v-model="editRoleDrawer.checkAll.value" @change="handleEditDrawerCheckAllChange">全选</el-checkbox>
              <div v-for="privilegeGroup in editRoleDrawer.privileges" :key="privilegeGroup.id">
                <one-group-checkboxs ref="editRoleDrawerPrivilege" :group-label="privilegeGroup.name" v-model="privilegeGroup._checkedPrivilegeIds" @change="handleEditDrawerCheckItemChange" :data="privilegeGroup.privileges" key-prop="id" label-prop="name" disabled-prop="_disabled"></one-group-checkboxs>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="drawerFoot">
        <el-button type="primary" @click="handleEditSave" :loading="editRoleDrawer.saving">{{ editRoleDrawer.saving ? '提交中' : '提交' }}</el-button>
        <el-button @click="editRoleDrawer.show = false">取 消</el-button>
      </div>
    </div>
  </el-drawer>
</div>
</template>

<script>
import BorderTable from "@/components/common/BorderTable.vue";
import OneGroupCheckboxs from "@/components/common/OneGroupCheckboxs";
import {
  log
} from 'util';
export default {
  components: {
    BorderTable,
    OneGroupCheckboxs
  },
  data() {
    return {
      styleObject: {
        height: ""
      },
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      tableHeight: null,
      rolesLoading: false,
      roleList: [],
      addRoleDrawer: {
        show: false,
        title: "添加角色",
        checkAll: {
          value: false
        },
        form: {
          name: "",
          comment: ""
        },
        formRules: {
          name: [{
            required: true,
            message: "角色名不能为空",
            trigger: "blur"
          }]
        },
        saving: false,
        privileges: []
      },
      editRoleDrawer: {
        show: false,
        title: "编辑角色",
        roleId: "",
        checkAll: {
          value: false
        },
        form: {
          name: "",
          comment: ""
        },
        formRules: {
          name: [{
            required: true,
            message: "角色名不能为空",
            trigger: "blur"
          }]
        },
        saving: false,
        privileges: []
      },
      selfRoleMapper: {},
      queryForm: {
        orgId: -1,
        isSystemRole: '',
        name: '',
        comment: '',
        isEnabled: ''
      }
    };
  },
  computed: {
    currentTreeId() {
      return this.$store.state.currentTreeId;
    },
    screenData() {
      return this.$store.state.screen;
    }
  },
  watch: {
    currentTreeId() {
      this.queryForm.orgId = this.currentTreeId;
      this.queryRoleList();
    },
    screenData() {
      this.tableHeight = document.body.clientHeight - 350 + "px";
    }
  },
  created() {
    this.makeheight();
    // this.tableHeightInit();
  },
  mounted() {
    this.querySelfRoles();
    this.queryRoleList();
  },
  methods: {
    search() {
      this.pagination.currentPage = 1;
      this.queryRoleList();
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      _this.tableHeight = window.innerHeight - 340;
      console.log(_this.tableHeight);
      window.onresize = () => {
        return (() => {
          _this.tableHeight = window.innerHeight - 340;
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    tableHeightInit() {
      this.tableHeight = document.body.clientHeight - 350 + "px";
    },
    querySelfRoles() {
      this.request.get("/front/system/role/query/self").then(resp => {
        if (resp.code != 200) {
          return this.msg.error(resp.msg);
        }
        let mapper = {};
        resp.data.forEach(item => {
          mapper[item.id] = item;
        });
        this.selfRoleMapper = mapper;
      });
    },
    queryRoleList() {
      this.rolesLoading = true;
      this.queryForm.page = this.pagination.currentPage;
      this.queryForm.pageSize = this.pagination.pageSize;
      this.queryForm.sort = "createTime";
      this.queryForm.order = "desc";
      let params = Object.assign({}, this.queryForm)
      this.request
        .get("/front/system/role/query", params)
        .then(rs => {
          if (rs.code == 200) {
            if (rs.total > 0) {
              this.roleList = rs.data;
            } else {
              this.roleList = [];
            }
            this.pagination.total = rs.total;
          } else {}
          this.rolesLoading = false;
        })
        .catch(error => {
          console.log(error);
          this.rolesLoading = false;
        });
    },
    handleAddClick() {
      this.addRoleDrawer.show = true;
      this.request.get("/front/system/privilege/query").then(resp => {
        if (resp.code != 200) {
          return this.msg.error(resp.msg);
        }
        resp.data.forEach(privilegeGroup => {
          privilegeGroup._checkedPrivilegeIds = [];
          privilegeGroup.privileges.forEach(item => {
            item._disabled = false;
          });
        });
        console.log(resp.data)
        this.addRoleDrawer.privileges = resp.data;
      });
    },
    handleAddRoleDrawerClose() {
      this.addRoleDrawer.show = false;
      this.$refs["addRoleDrawerForm"].resetFields();
      this.addRoleDrawer.checkAll.value = false;
      this.handleAddRoleDrawerCheckAllChange(false);
    },
    handleAddSave() {
      this.$refs["addRoleDrawerForm"].validate(valid => {
        if (!valid) {
          return this.msg.error("请按要求完善表单信息");
        }

        this.addRoleDrawer.saving = true;
        let param = this.getAddSaveParam();

        this.request.post("/front/system/role/add", param).then(resp => {
          this.addRoleDrawer.saving = false;
          if (resp.code != 200) {
            return this.msg.error(resp.msg);
          }
          this.msg.success("添加成功");
          this.handleAddRoleDrawerClose();
          this.pagination.currentPage = 1;
          this.queryRoleList();
        });
      });
    },
    getAddSaveParam() {
      let checked = [];
      this.addRoleDrawer.privileges.forEach(pg => {
        checked.push(...pg._checkedPrivilegeIds);
      });
      return {
        name: this.addRoleDrawer.form.name,
        comment: this.addRoleDrawer.form.comment,
        privilegeIds: checked
      };
    },
    handleAddRoleDrawerCheckAllChange(val) {
      this.$refs["addRoleDrawerPrivilege"].forEach(item => {
        item.selectAll(val);
      });
    },
    handleAddRoleDrawerCheckItemChange() {
      this.addRoleDrawer.checkAll.value = this.computeAddRoleDrawerIsAllItemChecked();
    },
    computeAddRoleDrawerIsAllItemChecked() {
      let checkedItems = this.$refs["addRoleDrawerPrivilege"].filter(item => {
        let status = item.getStatus();
        return status.isAllChecked;
      });
      return (
        this.$refs["addRoleDrawerPrivilege"].length === checkedItems.length
      );
    },
    handleEditClick(row) {
      if (this.selfRoleMapper[row.id]) {
        this.$confirm(
            "由于您当前属于该角色，编辑该角色的权限信息将导致您权限丢失。(找回丢失的权限需联系为您分配权限的人员)",
            "警告", {
              confirmButtonText: "继续",
              cancelButtonText: "取消",
              type: "warning"
            }
          )
          .then(() => {
            this.handleEditClickProcess(row);
          })
          .catch(() => {});
      } else {
        this.handleEditClickProcess(row);
      }
    },
    handleEditClickProcess(row) {
      this.editRoleDrawer.show = true;
      this.editRoleDrawer.roleId = row.id;
      this.editRoleDrawer.isSystem = row.isSystem;
       this.request.get(`/front/system/role/${row.id}`).then(rs => {
        if(rs.code !== 200){
          if(rs.code==500){
          return this.$message.error(rs.msg)
        }
          return 
        }
        this.editRoleDrawer.form.name = rs.data.name;
        this.editRoleDrawer.form.comment = rs.data.comment;
        const checkedPrivilegeMapper = {};
        rs.data.privileges.forEach(item => {
          checkedPrivilegeMapper[item.id] = item;
        });

        this.request.get("/front/system/privilege/query").then(rs => {
          if(rs.code !== 200){
            if(rs.code==500){
              return this.$message.error(rs.msg)
            }
            return
          }
          rs.data.forEach(privilegeGroup => {
            let _cp = privilegeGroup._checkedPrivilegeIds = [];
            privilegeGroup.privileges.forEach(item => {
              if(checkedPrivilegeMapper[item.id]){
                _cp.push(item.id);
              }
              item._disabled = false;
            });
          });
          this.editRoleDrawer.privileges = rs.data;

          //等组件数据绑定完成
          this.$nextTick(()=>{
            this.editRoleDrawer.checkAll.value = this.computeEditDrawerIsAllItemChecked();
          });

        });
      });
      // this.editRoleDrawer.form.name = row.name;
      // this.editRoleDrawer.form.comment = row.comment;

      // this.request.get('/front/system/privilege/query').then(resp => {
      //   if (resp.code != 200) {
      //     return this.msg.error(resp.msg);
      //   }

      //   resp.data.forEach(privilegeGroup => {
      //     privilegeGroup._checkedPrivilegeIds = [];
      //     privilegeGroup.privileges.forEach(item => {
      //       item._disabled = false;
      //       if (item.permitted) {
      //         privilegeGroup._checkedPrivilegeIds.push(item.pid);
      //       }
      //     });
      //   });

      //   this.editRoleDrawer.privileges = resp.data;

      //   //等组件数据绑定完成
      //   this.$nextTick(() => {
      //     this.editRoleDrawer.checkAll.value = this.computeEditDrawerIsAllItemChecked();
      //   });
      // });
    },
    handleEditDrawerCheckAllChange(val) {
      this.$refs["editRoleDrawerPrivilege"].forEach(item => {
        item.selectAll(val);
      });
    },
    handleEditDrawerCheckItemChange() {
      this.editRoleDrawer.checkAll.value = this.computeEditDrawerIsAllItemChecked();
    },
    computeEditDrawerIsAllItemChecked() {
      let checkedItems = this.$refs["editRoleDrawerPrivilege"].filter(item => {
        let status = item.getStatus();
        return status.isAllChecked;
      });
      return (
        this.$refs["editRoleDrawerPrivilege"].length === checkedItems.length
      );
    },
    handleEditDrawerClose() {
      this.editRoleDrawer.show = false;
      this.$refs["editRoleDrawerForm"].resetFields();
      this.editRoleDrawer.checkAll.value = false;
    },
    handleEditSave() {
      this.$refs["editRoleDrawerForm"].validate(valid => {
        if (!valid) {
          return this.msg.error("请按要求完善表单信息");
        }
        this.editRoleDrawer.saving = true;
        let param = this.getEditSaveParam();
        this.request.post("/front/system/role/update", param).then(resp => {
          this.editRoleDrawer.saving = false;
          if (resp.code != 200) {
            return this.msg.error(resp.msg);
          }
          this.msg.success("修改成功");
          this.handleEditDrawerClose();
          this.queryRoleList();
        });
      });
    },
    getEditSaveParam() {
      let checked = [];
      this.editRoleDrawer.privileges.forEach(pg => {
        checked.push(...pg._checkedPrivilegeIds);
      });
      return {
        id: this.editRoleDrawer.roleId,
        name: this.editRoleDrawer.form.name,
        comment: this.editRoleDrawer.form.comment,
        privilegeIds: checked
      };
    },
    handleDeleteClick(row) {
      if (this.selfRoleMapper[row.id]) {
        this.$confirm(
            "由于您当前属于该角色，删除该角色将导致您权限丢失。(找回丢失的权限需联系为您分配权限的人员)",
            "警告", {
              confirmButtonText: "继续",
              cancelButtonText: "取消",
              type: "warning"
            }
          )
          .then(() => {
            this.handleDeleteClickProcess(row);
          })
          .catch(() => {
            this.msg.info('已取消删除')
          });
      } else {
        this.$confirm("确定要进行删除操作吗？", "提示", {
            confirmButtonText: "继续",
            cancelButtonText: "取消",
            type: "info"
          })
          .then(() => {
            this.handleDeleteClickProcess(row);
          })
          .catch(() => {
            this.msg.info('已取消删除')            
          });
      }
    },
    handleDeleteClickProcess(row) {
      this.request.delete(`/front/system/role/${row.id}`).then(resp => {
        if (resp.code != 200) {
          this.msg.error(resp.msg);
          return;
        }
        this.msg.success("删除成功");
        this.pagination.currentPage = 1;
        this.queryRoleList();
      });
    },
    handleRoleCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage;
      this.queryRoleList();
    },
    handleRoleSizeChange(size) {
      this.pagination.pageSize = size;
      this.pagination.currentPage = 1;
      this.queryRoleList();
    },
    enabledRole(row) {
      this.request.post(`/front/system/role/enabled/${row.id}`).then(rs => {
        if (rs.code !== 200) {
          if(rs.code==500){
            return this.$message.error(rs.msg)
          }
          return
        }
        this.msg.info('操作成功');
        this.pagination.currentPage = 1;
        this.queryRoleList();
      });
    },
    disabledRole(row) {
      this.request.post(`/front/system/role/disabled/${row.id}`).then(rs => {
        if (rs.code !== 200) {
          if(rs.code==500){
            return this.$message.error(rs.msg)
          }
          return
        }
        this.msg.info('操作成功');
        this.pagination.currentPage = 1;
        this.queryRoleList();
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.rolesMContainer {
  .mainContent {
    margin: 12px;
    padding: 15px 0;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;

    .query {
      padding: 0 20px 20px;
    }

    .tableBox {
      padding: 0 20px;
    }

    .edit {
      background: #327ae6;
      color: #fff;
    }

    .del {
      background: #eaa13a;
      color: #fff;
    }

    .detail {
      background: #32AC63;
      color: #fff;
    }
  }
}
</style>
<style lang="scss">
.rolesMContainer {
  .drawerWrap .el-form .el-form-item__content .el-checkbox{
    
  }
  .mainContent {
    .query {
      .el-input {
        width: 200px;
        margin-right: 10px;

        .el-input__inner {
          line-height: 36px;
          height: 36px;
        }
      }

      .el-select {
        width: 170px;
        margin-right: 10px;

        .el-input {
          width: 170px;
          margin-right: 10px;

          .el-input__inner {
            line-height: 36px;
            height: 36px;
          }
        }
      }

      .el-radio.is-checked .el-radio__input.is-checked .el-radio__inner {
        border-color: #42bced;
        background: #42bced;
      }

      .el-radio.is-checked .el-radio__label {
        color: #147dd9 !important;
      }
    }

  }

  .formBox {
    .el-form-item {
      .content-panel {
        line-height: 40px;

        &>.el-checkbox {
          line-height: 50px;
        }
      }

      .privilege-form-item {
        padding: 0 10px;
      }
    }

  }

  .contentShowArea {
    // position: absolute;
    // top: 36px;
    // bottom: 0;
    // left: 0;
    // right: 0;
    // padding: 10px;

    // .el-table__header-wrapper {
    //   tr {
    //     background: #f8f8f8;

    //     th {
    //       background: #f8f8f8;
    //       border-bottom: 2px solid rgba(46, 91, 255, 0.5);
    //       color: #333333;
    //       padding: 10px 0;

    //       .cell {
    //         // font-weight: bold;
    //         font-family: PingFangBold;

    //         .caret-wrapper {
    //           height: 29px;

    //           .ascending {
    //             top: 3px;
    //           }

    //           .descending {
    //             bottom: 5px;
    //           }
    //         }
    //       }
    //     }
    //   }
    // }

    // .el-table__body-wrapper {
    //   tbody {
    //     tr {
    //       td {
    //         border: none;
    //         padding: 9px 0;

    //         .cell {
    //           color: #333;
    //         }
    //       }
    //     }
    //   }
    // }

    .el-table__fixed-right {
      &::before {
        display: none;
      }

      // .el-table__fixed-header-wrapper {
      //   tr {
      //     background: #f8f8f8;

      //     th {
      //       background: #f8f8f8;
      //       border-bottom: 2px solid rgba(46, 91, 255, 0.5);
      //       color: #333333;
      //       padding: 10px 0;

      //       .cell {
      //         // font-weight: bold;
      //         font-family: PingFangBold;

      //         .caret-wrapper {
      //           height: 29px;

      //           .ascending {
      //             top: 3px;
      //           }

      //           .descending {
      //             bottom: 5px;
      //           }
      //         }
      //       }
      //     }
      //   }
      // }

      .el-table__fixed-body-wrapper {
        tbody {
          tr {
            td {
              // border: none;
              // padding: 9px 0;

              .cell {
                text-align: center;

                .editBtn {
                  color: #28c6a2;
                }

                .delBtn {
                  color: #dd3071;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
